// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__ZQHbg","spinnerImage":"styles_spinnerImage__N30jg","rotation":"styles_rotation__NsCiR","spinnerText":"styles_spinnerText__hXqBa"};